import type { FieldIndicator } from './FieldIndicator'

interface FieldIndicatorInput {
  /** Client-side validation message, empty when the field passes. */
  error: string
  /** Submit-only failure, e.g. a phone-lookup rejection. */
  serverError: string
  /** Whether the field currently holds a value. */
  filled: boolean
  /**
   * Whether the field has actually been checked against the schema -- exited
   * once, or submitted. Not "the user visited it": touching a nonempty field
   * is no evidence it passes, so `valid` must rest on a real verdict.
   */
  validated: boolean
  /** Whether the field must be answered. */
  required: boolean
}

export const resolveFieldIndicator = ({
  error,
  filled,
  required,
  serverError,
  validated
}: FieldIndicatorInput): FieldIndicator => {
  // Server errors outrank client ones: they are the newer verdict, and they
  // render through the same slot rather than a second bespoke path.
  if (serverError !== '') return 'server-error'
  if (error !== '') return 'invalid'
  if (!filled) return required ? 'required' : 'unfilled'

  // A filled field that has not been checked is a restored draft or an autofill.
  // Claiming it valid would assert a verdict the schema never gave.
  return validated ? 'valid' : 'prefilled'
}
